import {
  CriticalCasePersonRole, CriticalCaseStatusCategory, CriticalCaseTargetType,
} from './critical-case.models';

export const CASE_STATUS_OPTIONS: { value: CriticalCaseStatusCategory; label: string }[] = [
  { value: 'OPEN', label: 'Em aberto' },
  { value: 'RESOLVED', label: 'Resolvido' },
  { value: 'CLOSED_UNRESOLVED', label: 'Fechado sem resolução' },
];

export const CASE_STATUS_LABELS: Record<CriticalCaseStatusCategory, string> = {
  OPEN: 'Em aberto',
  RESOLVED: 'Resolvido',
  CLOSED_UNRESOLVED: 'Fechado sem resolução',
};

export function caseStatusBadge(category: CriticalCaseStatusCategory): string {
  switch (category) {
    case 'OPEN': return 'bg-warning-soft';
    case 'RESOLVED': return 'bg-success-soft';
    case 'CLOSED_UNRESOLVED': return 'bg-secondary-soft';
  }
}

/** Escala de 1 a 3 do Admin; acima de 2 é vermelho, 2 âmbar, o resto neutro. */
export function severityBadge(level: number | null): string {
  if (level === null) return 'bg-secondary-soft';
  if (level >= 3) return 'bg-danger-soft';
  if (level === 2) return 'bg-warning-soft';
  return 'bg-info-soft';
}

export const PERSON_ROLE_LABELS: Record<CriticalCasePersonRole, string> = {
  EMPLOYEE: 'Colaborador',
  MANAGER: 'Gestor',
  RESPONSIBLE: 'Responsável',
  CREATED_BY: 'Registado por',
};

export const TARGET_TYPE_LABELS: Record<CriticalCaseTargetType, string> = {
  EMPLOYEE: 'Colaborador',
  CLIENT: 'Cliente',
};

/** Iniciais para o círculo da pessoa (até duas letras). */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  const first = parts[0].charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
  return (first + last).toUpperCase();
}
